/**
 * TagZone types
 *
 * @type {{}}
 */
export const types = {
  ceiling: 'ceiling',
  gate: 'gate',
  selfService: 'self_service',
  shelf: 'shelf',
  missing: 'missing',
  stock: 'stock'
};
export const tagZoneTypes = {
  [types.ceiling]: 'Потолок',
  [types.gate]: 'Выход',
  [types.selfService]: 'Самообслуживание',
  [types.shelf]: 'Полка',
  [types.missing]: 'Зона пропажи',
  [types.stock]: 'Склад'
};